import {createActionTypes} from "../utils/reduxUtils";

enum LoadingActions {
    SET_LOADING,
}

const actionTypes = createActionTypes(LoadingActions, "LOADING");

export default actionTypes;
